document.addEventListener("DOMContentLoaded", () => {
	initMobOffset();
});

window.addEventListener("resize", initMobOffset);

function initMobOffset() {
	let headings = document.querySelectorAll(".text-image-columns-section h2");
	if (!headings.length) return;

	headings.forEach(el => {
		let height = el.offsetHeight;
		let image = el.closest(".text-image-columns-section").querySelector(".img-holder");
		let fixedOffset = 31;
		if (window.innerWidth < 768) {
			image.style.paddingTop = height + fixedOffset + "px";
		} else {
			image.style.paddingTop = '';
		}
	});
}